import Vue from "vue";
import Router from "vue-router";
import Hjem from "./views/Hjem.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Hjem",
      component: Hjem
    },
    {
      path: "/Omoss",
      name: "Omoss",
      component: () => import("./views/Omoss.vue")
    },
    {
      path: "/Rreferanse",
      name: "Rreferanse",
      component: () => import("./views/Rreferanse.vue")
    },
    {
      path: "/Kontakt",
      name: "Kontakt",
      component: () => import("./views/Kontakt.vue")
    },
    {
      path: "/Tjenester",
      name: "Tjenester",
      component: () => import("./views/Tjenester.vue")
    },
    {
      path: "/SalgProdukter",
      name: "SalgProdukter",
      component: () => import("./views/SalgProdukter.vue")
    }

 
  ]
});
